import { NgModule, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationInterceptor } from './authentication.interceptor';
import { IdentityConfig } from './identity-config';
import { LOGIN_URL } from './tokens';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzFormModule } from 'ng-zorro-antd/form'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { TranslateModule } from '@ngx-translate/core'
import { TRANSLATION_GROUP_TOKEN, MmI18nModule } from 'mm-web-core/i18n';
import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { identityConstants } from './identity-constants';
import { en } from './i18n/en';
import { zh } from './i18n/zh';
import { CommonModule } from '@angular/common';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { AuthorizeDirective } from './directives/authorize.directive';
import { RoleManagementComponent } from './role-management/role-management.component';
import { PermissionManagementComponent } from './permission-management/permission-management.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { PermissionSelectComponent } from './permission-select/permission-select.component'
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { RoleFormComponent } from './role-form/role-form.component';
import { MmTableModule } from 'mm-web-core/table';
import { MmFormsModule } from 'mm-web-core/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTreeViewModule } from 'ng-zorro-antd/tree-view'
import { NzModalModule } from 'ng-zorro-antd/modal';
import { MmIconModule } from 'mm-web-core/icon';
import { UserDisplayNamePipe } from './user-display-name.pipe';
import { ExpiredTokenHandler } from './expired-token-handler';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NzMessageModule,
    NzFormModule,
    NzInputModule,
    ReactiveFormsModule,
    NzButtonModule,
    TranslateModule,
    NzTableModule,
    NzTreeModule,
    NzTreeSelectModule,
    FormsModule,
    MmTableModule,
    MmFormsModule,
    NzGridModule,
    NzIconModule,
    NzModalModule,
    MmI18nModule,
    MmIconModule,
    NzTreeViewModule
  ],
  exports: [
    LoginFormComponent,
    PermissionSelectComponent,
    RoleManagementComponent,
    UserDisplayNamePipe
  ],
  declarations: [
    LoginFormComponent,
    AuthorizeDirective,
    RoleManagementComponent,
    PermissionManagementComponent,
    PermissionSelectComponent,
    RoleFormComponent,
    UserDisplayNamePipe
  ],
  providers: [],
})
export class MmIdentityModule {
  static forRoot(config: IdentityConfig = { loginUrl: "Login" }): ModuleWithProviders<any> {
    return {
      ngModule: MmIdentityModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthenticationInterceptor,
          multi: true
        },
        {
          provide: LOGIN_URL,
          useValue: config.loginUrl,
          multi: false
        },
        {
          provide: ExpiredTokenHandler,
          useClass: ExpiredTokenHandler,
          deps: [Router, ActivatedRoute],
          multi: false

        }
      ]
    }
  }
}
